// season 类型
export const SEASON_TYPE_MAP = {
  DOCUMENTARY: 3, // 纪录片
}

// index type
export const INDEX_TYPE_MAP = {
  DOCUMENTARY: 3, // 纪录片
}

// 类型
export const TYPE_MAP = {
  WEB: 1,
}

// 筛选类型
export const FIELD_MAP = {
  STYLE_ID: 'style_id',
  PRODUCER_ID: 'producer_id',
  RELEASE_DATE: 'release_date',
}

export const NAV_NAME_MAP = {
  [FIELD_MAP.STYLE_ID]: '你喜欢什么风格的？',
  [FIELD_MAP.PRODUCER_ID]: '更偏爱哪个出品方？',
  [FIELD_MAP.RELEASE_DATE]: '或许你对年份也有要求？',
}

// 标题栏
export const NAV_MAP = {
  OPTION: 'option',
  RECOMMEND: 'recommend',
}

// 默认的 play ids
export const PLAY_IDS = [
  {
    line: [
      { id: 59825, name: 'B站必刷' },
      { id: 59834, name: '宝藏甄选' },
    ],
  },
  {
    line: [
      { id: 59836, name: '获奖佳作' },
      { id: 59835, name: '经典系列' },
      { id: 59837, name: '记录生活' },
    ],
  },
]

// spmid
export const SPM_ID = '666.83'

// 排序类型
export const ORDER_MAP = [
  { label: '播放数量', order: 2 },
  { label: '最高评分', order: 4 },
  { label: '最新上映', order: 6 },
]

// pagesize
export const PAGE_SIZE = 24
